import React from 'react'

const Flexbox_Coding_Assignment_2 = () => {
  return (
    <div>
      <h1>Coding Assignment 2</h1>
    </div>
  )
}

export default Flexbox_Coding_Assignment_2
